import OfficeListView from "../views/Office/OfficeList";
import OfficeRegisterView from "../views/Office/OfficeRegister";
import HierarchyRegisterView from "../views/Hierarchy/HierarchyRegister";
import OfficeHomeView from "../views/Office/OfficeHome";
import { ARCHIVED_CASES, CASE_INFO, CASE_REGISTER, HIERARCHY_EDIT, HIERARCHY_REGISTER, OFFICE_EDIT, OFFICE_HOME, OFFICE_MEMBERS, OFFICE_REGISTER, OFFICE_SETTINGS, OFFICES, PROFILE } from "./routes";
import OfficeLayout from "../layouts/OfficeLayout";
import CaseRegister from "../views/Case/CaseRegister";
import OfficeMembersView from "../views/Office/OfficeMembers";
import OfficeSettingsView from "../views/Office/OfficeSettings";
import CaseInfoView from "../views/Case/CaseInfo";
import Profile from "../views/Profile/Profile";
import ArchivedCasesView from "../views/Office/ArchivedCases";
import AppShell from "../layouts/AppShell";


export const privateRoutes = [
  {
    element: <AppShell />, 
    children: [
      { path: OFFICES, element: <OfficeListView /> },
      { path: OFFICE_REGISTER, element: <OfficeRegisterView /> },
      { path: OFFICE_EDIT, element: <OfficeRegisterView /> },
      { path: HIERARCHY_REGISTER, element: <HierarchyRegisterView /> },
      { path: HIERARCHY_EDIT, element: <HierarchyRegisterView /> },
      { path: PROFILE, element: <Profile /> },
    ]
  },
  {
    element: <OfficeLayout />,
    children: [
      { path: OFFICE_HOME, element: <OfficeHomeView /> },
      { path: OFFICE_SETTINGS, element: <OfficeSettingsView /> },
      { path: OFFICE_MEMBERS, element: <OfficeMembersView /> },
      { path: CASE_REGISTER, element: <CaseRegister /> },
      { path: CASE_INFO, element: <CaseInfoView /> },
      { path: ARCHIVED_CASES, element: <ArchivedCasesView /> },
    ],
  },
];